var standardCss = '#bkk-klinikfinder-searchlet, #bkk-arztfinder-searchlet { padding: 10px 0px; width: 100%; }\n'
    + '.bkk-searchlet-fieldset label {\n'
    + '    display: block;\n'
    + '    padding-top: 20px;\n'
    + '}\n'
    + '.bkk-searchlet-fieldset input[type="text"], .bkk-searchlet-fieldset input[type="submit"], .bkk-searchlet-fieldset select, .bkk-searchlet-fieldset button {\n'
    + '    font-size: 14px;\n'
    + '    background-color: #fff;\n'
    + '    border-radius: 0;\n'
    + '    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\n'
    + '    transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n'
    + '    color: #aaa;\n'
    + '    border: 0 none;\n'
    + '    padding: 5px 10px;\n'
    + '    display:block;\n'
    + '    width: 100%;\n'
    + '}\n'
    + '.bkk-searchlet-fieldset input::placeholder {\n'
    + '    color: #bbb;\n'
    + '    opacity: 1;\n'
    + '}\n'
    + '.bkk-searchlet-fieldset input[type="text"], .bkk-searchlet-fieldset select {'
    + '    border: 1px solid #cdcdcd;\n'
    + '    color: #000;\n'
    + '    box-shadow: none;\n'
    + '}\n'
    + '.bkk-searchlet-fieldset input[type="text"]:focus, .bkk-searchlet-fieldset select:focus {'
    + '    border:1px solid #aaa;\n'
    + '    box-shadow: 0 0 5px rgba(0, 0, 0, .175);\n'
    + '}\n'
    + '.bkk-searchlet-submit-button-placeholder {'
    + '    padding: 10px 0px;\n'
    + '}\n'
    + '.bkk-searchlet-fieldset button {\n'
    + '    color:#fff;\n'
    + '    background-color:#000;\n'
    + '    cursor:pointer;\n'
    + '}\n'
    + '.bkk-searchlet-fieldset button:hover {\n'
    + '    color: #fed800;\n'
    + '}\n'
    + '.bkk-searchlet-fieldset label span {\n'
    + '    margin-left: 8px;\n'
    + '}\n';

export default function getStandardCss() {
    return standardCss;
}